
import { email
} from 'react-admin';

var EMAIL_REGEX = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/; // eslint-disable-line no-useless-escape


export const validateMaxLength = (max, message = '') => {    
  let msg = message.replace('%{max}', max);
  return (
    value => value && value.length > max ? msg : undefined
  );
};

export const validateMinMaxLengthAndCharacters = (message = '') => {  
    
  let msg = message.replace('%{max}', 15);
  msg = msg.replace('%{min}', 8);
    
  var decimal=  /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9])(?!.*\s).{8,15}$/;
    
  return (value => value && value.match(decimal) ? undefined : msg);

};

export const validarDNIUEGeneric = (dni) => {
  // Expressió regular genèrica per a DNIs europeus
  const regExpGenericUE = /^[A-Z0-9]{5,15}$/i;
  return regExpGenericUE.test(dni);
};

export const validarNIF = (nif) => {
  const regExpNIF = /^[0-9]{8}[TRWAGMYFPDXBNJZSQVHLCKE]$/i;
  return regExpNIF.test(nif);
}

export const validarCIF = (cif) => {
  const regExpCIF = /^[ABCDEFGHJKLMNPQRSUVW][0-9]{7}[0-9A-J]$/i;
  return regExpCIF.test(cif);
}

export const validarDNI = (dni) => {
  const regExpDNI = /^[0-9]{8}[A-Z]$/i;
  const letrasDNI = 'TRWAGMYFPDXBNJZSQVHLCKE';
  const letraControl = letrasDNI.charAt(parseInt(dni, 10) % 23);
  return regExpDNI.test(dni) && dni.charAt(8).toUpperCase() === letraControl;
}

/*
export var regex = lodashMemoize(function (pattern, message) {
    if (message === void 0) { message = 'ra.validation.regex'; }
    return function (value, values) {
        return !isEmpty(value) && typeof value === 'string' && !pattern.test(value)
            ? getMessage(message, { pattern: pattern }, value, values)
            : undefined;
    };
}, function (pattern, message) {
    return pattern.toString() + message;
});*/

/*export const validateEmail = ( message = '') => {    
    return (
    value => value && !email() ? message : undefined
    );
};*/
export const validateEmail = () => {    
  return (
    email()
  );
};

export const validateTrue = (message = '') => {
    
  return (
    value => !value ? message : undefined
  );
};


export const validateInteger = (message = '') =>
{    
  return (
    value => value && ( isNaN(Number(value)) || !(isNaN(Number(value))) && (value > 10000000 || value < 0) ) ? message : undefined
  );
};

export const validateDouble = (message = '') =>
{    
  return (
    value => value && ( isNaN(Number(value)) || !(isNaN(Number(value))) && (value > 100000000 || value < -100000000) ) ? message : undefined
  );
};

export const validateDoubleGreatZero = (message = '') =>
{    
  return (
    value => value && ( isNaN(Number(value)) || !(isNaN(Number(value))) && (value <= 0 ) ) ? message : undefined
  );
};
    
export const validateNumber = (message = 'Must be a number') =>
  value => value && isNaN(Number(value)) ? message : undefined;
    
export const validatePercent = (message = '') =>
{    
  return (
    value => value && ( isNaN(Number(value)) || !(isNaN(Number(value))) && (value > 100 || value < 0) ) ? message : undefined
  );
};